import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button, Form, InputGroup, Card } from "react-bootstrap";

import { UpdateJobGroupName, UpdateJobGroupDescription, UpdateJobGroupState, ClearJobGroupState } from "../../Store";
import { getAllJobGroups, createJobGroup, updateJobGroup, deleteJobGroup } from "../../Store/Thunk";

export default function JobGroup() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const jobGroupList = useSelector((state) => state.organization.jobGroupList);
  const jobGroupName = useSelector((state) => state.organization.jobGroupName);
  const jobGroupDescription = useSelector((state) => state.organization.jobGroupDescription);
  const jobGroupId = useSelector((state) => state.organization.jobGroupId);
  const isUpdateOperation = useSelector((state) => state.organization.isJobGroupUpdateOperation);

  useEffect(() => {
    dispatch(getAllJobGroups());
  }, [dispatch]);

  const submitForm = (event) => {
    event.preventDefault();

    if (isUpdateOperation) {
      dispatch(
        updateJobGroup({
          id: jobGroupId,
          name: jobGroupName,
          description: jobGroupDescription,
        })
      );
    } else {
      dispatch(
        createJobGroup({
          name: jobGroupName,
          description: jobGroupDescription,
        })
      );
    }

    dispatch(ClearJobGroupState());
  };

  const handleUpdateButton = (item) => {
    dispatch(
      UpdateJobGroupState({
        id: item.id,
        name: item.name,
        description: item.description || "",
        isUpdateOperation: true,
      })
    );
  };

  const handleDeleteButton = (id) => {
    dispatch(deleteJobGroup(id));
  };

  return (
    <div>
      <Card body className="mb-3 default-card admin-form">
        <Form onSubmit={submitForm}>
          <Row>
            <Col xs={12} md={5}>
              <h6>{isUpdateOperation ? `${t("update")}: ${jobGroupId}` : t("jobGroupName")}</h6>
              <InputGroup className="mb-3">
                <Form.Control
                  required
                  name="name"
                  placeholder={t("enterJobGroupName")}
                  value={jobGroupName}
                  onChange={(e) => dispatch(UpdateJobGroupName(e.target.value))}
                />
              </InputGroup>
            </Col>
            <Col xs={12} md={5}>
              <h6>{t("description")}</h6>
              <InputGroup className="mb-3">
                <Form.Control
                  name="description"
                  placeholder={t("enterDescription")}
                  value={jobGroupDescription}
                  onChange={(e) => dispatch(UpdateJobGroupDescription(e.target.value))}
                />
              </InputGroup>
            </Col>
            <Col xs={12} md={2}>
              <Row style={{ height: !isUpdateOperation && "100%", margin: 0 }}>
                <Button
                  className="mb-1"
                  type="submit"
                  style={{ width: "100%", height: "100%" }}
                  variant="primary"
                  disabled={!jobGroupName}
                >
                  {isUpdateOperation ? t("update") : t("create")}
                </Button>
              </Row>
              {isUpdateOperation && (
                <Row style={{ margin: 0 }}>
                  <Button
                    style={{ width: "100%", height: "100%" }}
                    variant="secondary"
                    onClick={() => dispatch(ClearJobGroupState())}
                  >
                    {t("decline")}
                  </Button>
                </Row>
              )}
            </Col>
          </Row>
        </Form>
      </Card>

      <h5>{t("jobGroupList")}</h5>
      {jobGroupList &&
        jobGroupList.map((item, i) => (
          <Card className="mb-2" key={"jobGroup" + i}>
            <Card.Body>
              <Row className="align-items-center">
                <Col xs={1}>{item.id}</Col>
                <Col xs={3}>{item.name}</Col>
                <Col xs={5}>{item.description}</Col>
                <Col xs={3}>
                  <Row xs="auto" className="justify-content-end">
                    <Col>
                      <Button size="sm" variant="success" onClick={() => handleUpdateButton(item)}>
                        {t("updateButtonLabel")}
                      </Button>
                    </Col>
                    <Col>
                      <Button size="sm" variant="danger" onClick={() => handleDeleteButton(item.id)}>
                        {t("deleteButtonLabel")}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ))}
    </div>
  );
}
